// Serviço para gerenciar chamadas da API do módulo ClinicSettings
import apiClient from './authService'

export const clinicService = {
  // Buscar informações da clínica
  async getClinicInfo() {
    try {
      const response = await apiClient.get(`/api/v1/clinicsettings/`);
      return response.data;
    } catch (error) {
      console.warn('⚠️ Erro ao buscar informações da clínica:', error.message || error);
      // Retorna dados padrão em caso de erro para não falhar a aplicação
      return {
        name: 'Clínica',
        logo_url: null,
        login_logo_url: null,
        styles: {}
      }
    }
  },

  // Atualizar informações da clínica
  async updateClinicInfo(clinicData) {
    try {
      const response = await apiClient.put(`/api/v1/clinic_settings`, clinicData)
      return response.data
    } catch (error) {
      console.error('Erro ao atualizar informações da clínica:', error)
      throw error
    }
  },

  // Fazer upload do logo
  async uploadLogo(file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      
      const response = await apiClient.post(`/api/v1/clinic_settings/logo/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao fazer upload do logo:', error)
      throw error
    }
  },

  // Fazer upload do logo de login
  async uploadLoginLogo(file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      
      const response = await apiClient.post(`/api/v1/clinic_settings/login_logo/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao fazer upload do logo de login:', error)
      throw error
    }
  },

  // Buscar estilos da clínica
  async getClinicStyles() {
    try {
      const response = await apiClient.get(`/api/v1/clinic_settings/styles/`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar estilos da clínica:', error)
      throw error
    }
  },

  // Buscar logo para relatórios
  async getReportLogo() {
    try {
      const response = await apiClient.get(`/api/v1/clinic_settings/report_logo/`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar logo para relatórios:', error)
      throw error
    }
  },

  // Buscar logo para entrega
  async getDeliveryLogo() {
    try {
      const response = await apiClient.get(`/api/v1/clinic_settings/delivery_logo/`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar logo para entrega:', error)
      throw error
    }
  }
}

export default clinicService 